Monitoring.Dashboard ||= {}

class Monitoring.Dashboard.SocialContentImageTagsView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents/tags_editor/social_content_image_tags']

  events:
    'click .tagging-button': '_onTagClick'
  render: ->
    @$el.html(@template(model: @model, self: @))
    @$el

  onRejectionTag: ->
    @trigger('imageRejected')

  getIconFor:(tag) ->
    #TODO: To be defined with the real tags
    mapping = {
      'test_image_tag_1': '<i class="fa fa-phone"></i>',
      'test_image_tag_2': '<i class="fa fa-envelope-o"></i>',
      'test_image_tag_3': '<i class="fa fa-thumb-tack"></i>',
      'test_image_tag_4': '<i class="fa fa-link"></i>'
    }
    mapping[tag.code]

  _onTagClick:(event) ->
    $element = $(event.currentTarget)
    if $element.hasClass('active')
      @trigger('clearRejection') if $element.hasClass('implies-rejection') && @_onlyRejectionTag($element.data('code' ))
    else
      @trigger('imageRejected') if $element.hasClass('implies-rejection')

  _onlyRejectionTag:(tag_code) ->
    main = @model.mainTags()
    analyzed_tags = main.filter (tag) => tag.implies_rejection && @model.hasTag(tag) && tag.code != tag_code && @$el.find("[data-code='#{tag.code}']").hasClass('active')
    analyzed_tags.length == 0